import type { GaApp } from '~/modules/app'
import type {
  ApiGameConfiguration,
  ApiLeaderboardPreviousResponse,
  ApiLeaderboardResponse,
  ApiPrizeModel,
  ApiUserPositionsResponse,
  IUser,
} from '~/modules/main/types'

export class ApiService {
  gaApp: GaApp

  constructor(gaApp: GaApp) {
    this.gaApp = gaApp
  }

  async getUser(): Promise<IUser> {
    const response = await this.gaApp.repositories.main.main.getUser({
      abortKey: 'get-user-abort-key',
    })

    return response.data as IUser
  }

  async catchPrize(): Promise<string | null> {
    try {
      const response = await this.gaApp.repositories.main.main.catchPrize()

      return response.data as string
    } catch (error: unknown) {
      // Бизнес-ошибка (недостаточно монет) — без ретрая; сетевые пробрасываем наружу
      const typedError = error as { statusCode?: number; reason?: string }

      if (
        typedError?.statusCode === 400 &&
        typedError?.reason === 'ValidationFailed'
      ) {
        this.gaApp.services.notification.main.open(
          this.gaApp.i18n.t('main.roulette.notEnoughCoins'),
        )

        return null
      }

      throw error
    }
  }

  async getPrizes(): Promise<ApiPrizeModel[]> {
    const response = await this.gaApp.repositories.main.main.getPrizes()

    return response.data as ApiPrizeModel[]
  }

  async getGameConfiguration(): Promise<ApiGameConfiguration> {
    const response =
      await this.gaApp.repositories.main.main.getGameConfiguration()

    return response.data as ApiGameConfiguration
  }

  async updateDailyModalState(): Promise<{ statusCode: number }> {
    const response =
      await this.gaApp.repositories.main.main.updateDailyModalState()

    return response
  }

  async updateRatingResultsModalState(): Promise<{ statusCode: number }> {
    const response =
      await this.gaApp.repositories.main.main.updateRatingResultsModalState()

    return response
  }

  async updatePromoModalState(): Promise<{ statusCode: number }> {
    const response =
      await this.gaApp.repositories.main.main.updatePromoModalState()

    return response
  }

  async getLeaderboardCurrent(): Promise<ApiLeaderboardResponse> {
    const response =
      await this.gaApp.repositories.main.main.getLeaderboardCurrent({
        abortKey: 'get-leaderboard-current-abort-key',
      })

    return response.data as ApiLeaderboardResponse
  }

  async getLeaderboardPrevious(): Promise<ApiLeaderboardPreviousResponse> {
    const response =
      await this.gaApp.repositories.main.main.getLeaderboardPrevious({
        abortKey: 'get-leaderboard-previous-abort-key',
      })

    return response.data as ApiLeaderboardPreviousResponse
  }

  async getLeaderboardMyPositions(): Promise<ApiUserPositionsResponse> {
    const response =
      await this.gaApp.repositories.main.main.getLeaderboardMyPositions({
        abortKey: 'get-leaderboard-my-positions-abort-key',
      })

    return response.data as ApiUserPositionsResponse
  }
}
